import { api, query } from '@organization/api'
import { deviceSession, showApiErrors } from '@shared/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App, Button, ButtonProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = ButtonProps

export const DeleteTrustedDevices = ({ ...props }: Props) => {
  const { t } = useTranslation()
  const { message, modal } = App.useApp()
  const queryClient = useQueryClient()
  const { deviceToken } = deviceSession()

  const { mutateAsync: deleteTrustedDevices, isPending: isPendingDelete } =
    useMutation({
      mutationFn: api.mfa.deleteAllTrustedDevices,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [query.mfa.getTrustedDevices().queryKey[0]]
        })
        message.success(t('devices_deleted'))
      },
      onError: (error) => showApiErrors(error)
    })

  const onDelete = () => {
    modal.confirm({
      title: t('confirm_delete_devices'),
      content: t('confirm_delete_devices_info'),
      onOk: () =>
        deleteTrustedDevices({ deviceToken: deviceToken ?? undefined })
    })
  }

  return (
    <Button
      type="primary"
      loading={isPendingDelete}
      onClick={onDelete}
      {...props}
    >
      {t('delete_all_devices')}
    </Button>
  )
}
